import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const useModalBackButton = (onClose?: () => void, active?: boolean) => {
  const history = useHistory()

  useEffect(() => {
    if (!active) return

    const unblock = history.block(() => {
      onClose?.()
      unblock()
      return false
    })

    return () => {
      unblock()
    }
  }, [history, onClose, active])
}

export default useModalBackButton
